export default __webpack_public_path__ + "static/endo-tru-products-video-e617a6001ad6927382e81c97754444e4.mp4";